import { render, staticRenderFns } from "./GovernmentsGrid.vue?vue&type=template&id=eefd3630&"
import script from "./GovernmentsGrid.vue?vue&type=script&lang=js&"
export * from "./GovernmentsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports